var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.is_case_mode,
          expression: "is_case_mode"
        }
      ],
      staticClass: "pane-tag-case",
      attrs: { id: "pane-tag-case" }
    },
    [_vm._v("\n    " + _vm._s(_vm.case_name) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }